/* RSI v2 · Liten malmotor for designfilene fra Claude Design.
   Støtter [[uttrykk]] i tekst og attributter, <sc-for list="[[liste]]" as="x">, <sc-if value="[[flagg]]">,
   og hendelser som onClick="[[fn]]". Komponenten skrives som i designet: class X extends DCLogic { renderVals() {...} }.
   Oppdaterer bare attributter og tekst som faktisk endres, slik at animasjoner går jevnt. */
(function () {
  'use strict';
  if (window.RSIDC) return; // allerede lastet
  var RE = /\[\[([^\]]+)\]\]/g;

  function resolve(expr, scope) {
    expr = expr.trim();
    if (expr === 'true') return true;
    if (expr === 'false') return false;
    var parts = expr.split('.'), v = scope;
    for (var i = 0; i < parts.length; i++) { if (v == null) return ''; v = v[parts[i]]; }
    return v;
  }
  function interp(tpl, scope) {
    var m = /^\[\[([^\]]+)\]\]$/.exec(tpl);
    if (m) { var v = resolve(m[1], scope); return v == null ? '' : String(v); }
    return tpl.replace(RE, function (_, e) { var v = resolve(e, scope); return v == null ? '' : String(v); });
  }
  function isTag(n, t) { return n.nodeType === 1 && n.localName && n.localName.toLowerCase() === t; }

  function compile(root, out) {
    var kids = Array.prototype.slice.call(root.childNodes);
    kids.forEach(function (n) {
      if (isTag(n, 'sc-for') || isTag(n, 'sc-if')) {
        var anchor = document.createComment(n.localName);
        var frag = document.createDocumentFragment();
        while (n.firstChild) frag.appendChild(n.firstChild);
        var b = isTag(n, 'sc-for')
          ? { t: 'for', anchor: anchor, frag: frag, list: (n.getAttribute('list') || '').replace(/^\[\[|\]\]$/g, ''), as: n.getAttribute('as'), inst: [] }
          : { t: 'if', anchor: anchor, frag: frag, val: (n.getAttribute('value') || '').replace(/^\[\[|\]\]$/g, ''), inst: null };
        n.parentNode.replaceChild(anchor, n);
        out.push(b);
        return;
      }
      if (n.nodeType === 3) {
        if (n.data.indexOf('[[') > -1) out.push({ t: 'text', node: n, tpl: n.data, last: null });
        return;
      }
      if (n.nodeType !== 1) return;
      Array.prototype.slice.call(n.attributes).forEach(function (a) {
        if (a.value.indexOf('[[') < 0) return;
        var name = a.name;
        if (/^on[a-z]+$/i.test(name)) {
          n.removeAttribute(name);
          var ev = { t: 'ev', expr: a.value.replace(/^\[\[|\]\]$/g, ''), scope: null };
          var type = name.slice(2).toLowerCase();
          n.addEventListener(type, function (e) { var f = resolve(ev.expr, ev.scope); if (typeof f === 'function') f(e); });
          out.push(ev);
        } else {
          var real = name.indexOf('data-rsi-a-') === 0 ? name.slice(11) : name;
          out.push({ t: 'attr', el: n, name: real, tpl: a.value, last: null });
          if (name !== 'style') n.removeAttribute(name);
        }
      });
      compile(n, out);
    });
    return out;
  }

  function compileList(nodes, out) {
    var f = document.createDocumentFragment();
    nodes.forEach(function (n) { f.appendChild(n); });
    compile(f, out);
    // nodelisten kan ha endret seg (sc-for erstattet med kommentar)
    var arr = Array.prototype.slice.call(f.childNodes);
    nodes.length = 0; arr.forEach(function (n) { nodes.push(n); });
    return f;
  }

  function removeInst(inst) {
    if (!inst) return;
    (inst.binds || []).forEach(function (b) {
      if (b.t === 'for') { b.inst.forEach(removeInst); b.inst = []; }
      else if (b.t === 'if' && b.inst) { removeInst(b.inst); b.inst = null; }
    });
    (inst.nodes || []).forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
  }

  function update(binds, scope) {
    for (var i = 0; i < binds.length; i++) {
      var b = binds[i];
      if (b.t === 'text') { var v = interp(b.tpl, scope); if (v !== b.last) { b.node.data = v; b.last = v; } }
      else if (b.t === 'attr') {
        var w = interp(b.tpl, scope);
        if (b.name === 'value' && b.el.tagName === 'SELECT') {
          // <select value> må settes som egenskap, og valgene finnes først når rendringen er ferdig – derfor også setTimeout.
          if (w !== b.last) {
            var fe = b.el; fe.setAttribute('value', w); if (fe.value !== w) fe.value = w;
            setTimeout(function (el, val) { return function () { if (el.value !== val) el.value = val; }; }(fe, w), 0);
            b.last = w;
          }
        }
        else if (w !== b.last) {
          if (b.name === 'style') b.el.style.cssText = w; else b.el.setAttribute(b.name, b.name === 'href' ? mapUrl(w) : w);
          b.last = w;
        }
      }
      else if (b.t === 'ev') b.scope = scope;
      else if (b.t === 'for') {
        var list = resolve(b.list, scope) || [];
        while (b.inst.length > list.length) { removeInst(b.inst.pop()); }
        while (b.inst.length < list.length) {
          var binds2 = [], nodes = Array.prototype.slice.call(b.frag.cloneNode(true).childNodes);
          var f = compileList(nodes, binds2);
          var inst = { nodes: Array.prototype.slice.call(f.childNodes), binds: binds2 };
          fixLinks(f);
          b.anchor.parentNode.insertBefore(f, b.anchor);
          b.inst.push(inst);
        }
        for (var k = 0; k < list.length; k++) {
          var s = Object.create(scope); s[b.as] = list[k];
          update(b.inst[k].binds, s);
        }
      }
      else if (b.t === 'if') {
        var on = !!resolve(b.val, scope);
        if (on && !b.inst) {
          var binds3 = [], nodes3 = Array.prototype.slice.call(b.frag.cloneNode(true).childNodes);
          var f3 = compileList(nodes3, binds3);
          b.inst = { nodes: Array.prototype.slice.call(f3.childNodes), binds: binds3 };
          fixLinks(f3);
          b.anchor.parentNode.insertBefore(f3, b.anchor);
        } else if (!on && b.inst) {
          removeInst(b.inst);
          b.inst = null;
        }
        if (b.inst) update(b.inst.binds, scope);
      }
    }
  }


  // ── Lenker: designets «Navn.dc.html?x» -> ekte Shopify-adresser (tabell i window.RSI_LINKS)
  function mapUrl(h) {
    if (!h || h.indexOf('.dc.html') < 0) return h;
    var L = window.RSI_LINKS || {}, m = /^([A-Za-z0-9-]+)\.dc\.html(\?[^#]*)?(#.*)?$/.exec(h);
    if (!m) return h;
    var name = m[1], q = m[2] || '', hash = m[3] || '', u = null;
    if (name === 'Artikkel') {
      var a = /[?&]a=([^&]+)/.exec(q), sl = a ? ((window.RSI_ASLUG || {})[a[1]] || a[1]) : ''; u = (L.blog || '/blogs/reiseguide-bali') + (sl ? '/' + sl : ''); q = '';
    } else u = L[name];
    if (u == null) u = L.Forside || '/';
    return u + q + hash;
  }
  window.RSI_URL = mapUrl;
  // Amerikansk datoformat (MM/DD/YYYY) på .com: skråstrekene settes inn mens man skriver
  document.addEventListener('input', function (e) {
    var el = e.target; if (!el || !el.hasAttribute || !el.hasAttribute('data-rsi-us-date')) return;
    var d = el.value.replace(/\D/g, '').slice(0, 8), out = d;
    if (d.length > 4) out = d.slice(0, 2) + '/' + d.slice(2, 4) + '/' + d.slice(4); else if (d.length > 2) out = d.slice(0, 2) + '/' + d.slice(2);
    el.value = out;
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href'); if (h && h.indexOf('.dc.html') > -1) { e.preventDefault(); location.href = mapUrl(h); }
  }, true);
  function fixLinks(root) {
    var as = root.querySelectorAll ? root.querySelectorAll('a[href]') : [];
    for (var i = 0; i < as.length; i++) {
      var h = as[i].getAttribute('href'); if (!h || h.indexOf('.dc.html') < 0) continue;
      var am = /^Artikkel\.dc\.html\?a=([a-z0-9-]+)/.exec(h); if (am) as[i].setAttribute('data-rsi-a', am[1]);
      if (/^Guide\.dc\.html/.test(h)) as[i].setAttribute('data-rsi-a', 'ubud-guide');
      as[i].setAttribute('href', mapUrl(h));
    }
  }
  // ── Skjema: sender til Shopify (kontaktskjema) og viser takk-meldingen i designet
  function fieldLabel(el) {
    var l = el.closest('label'); if (l) { var t = (l.childNodes[0] && l.childNodes[0].textContent || l.textContent || '').trim(); if (t) return t.split('\n')[0].trim(); }
    if (el.id) { var lb = document.querySelector('label[for="' + el.id + '"]'); if (lb) return lb.textContent.trim(); }
    var w = el.closest('.fld,.field,.fg'); if (w) { var h = w.querySelector('label,small,span'); if (h && h !== el) return h.textContent.trim(); }
    return el.getAttribute('aria-label') || el.getAttribute('placeholder') || el.name || 'Felt';
  }
  function postNative(type, fields, back) {
    var sf = document.getElementById(type === 'contact' ? 'rsiContactForm' : 'rsiCustomerForm');
    if (sf) {
      (back ? fields.concat([['return_to', back]]) : fields).forEach(function (kv) {
        var el = sf.querySelector('[name="' + kv[0] + '"]');
        if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = kv[0]; sf.appendChild(el); }
        el.value = kv[1];
      });
      if (sf.requestSubmit) sf.requestSubmit(); else sf.querySelector('button[type="submit"]').click();
      return;
    }
    var f = document.createElement('form');
    f.method = 'post'; f.action = (window.RSI_LINKS && window.RSI_LINKS.contactPost) || '/contact'; f.acceptCharset = 'UTF-8'; f.style.display = 'none';
    var all = [['form_type', type], ['utf8', '\u2713'], ['return_to', back]].concat(fields);
    all.forEach(function (kv) { var i = document.createElement(kv[0] === 'contact[body]' ? 'textarea' : 'input'); i.name = kv[0]; i.value = kv[1]; if (i.tagName === 'INPUT') i.type = 'hidden'; f.appendChild(i); });
    document.body.appendChild(f); f.submit();
  }
  function backUrl(key, val) {
    var u = new URL(location.href); u.searchParams.set(key, val); u.hash = ''; return u.pathname + u.search;
  }
  window.RSISending = function (e) {
    var b = e && e.target && e.target.closest && e.target.closest('button'); if (!b) return;
    b.disabled = true; b.style.opacity = '.7';
    b.textContent = document.documentElement.lang === 'en' ? 'Sending …' : 'Sender …';
  };
  // Samler alt kunden har skrevet og valgt i et lesbart sammendrag
  function gather(srcEl, subject) {
    var src = (srcEl && srcEl.closest && (srcEl.closest('form') || srcEl.closest('.rsi-page'))) || document;
    var page = srcEl && srcEl.closest && srcEl.closest('.rsi-page') || document;
    var email = '', name = '', phone = '', lines = [subject, ''];
    var scope = src.tagName === 'FORM' ? src : page;
    scope.querySelectorAll('input,textarea,select').forEach(function (el) {
      if (el.closest('#rsiContactForm,#rsiCustomerForm')) return;
      if (el.type === 'hidden' || el.type === 'submit' || el.type === 'button') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      var v = (el.value || '').trim(); if (!v) return;
      var k = fieldLabel(el);
      if (!email && (el.type === 'email' || /@/.test(v) && /e-?post|email/i.test(k))) email = v;
      if (!name && /navn|name/i.test(k)) name = v;
      if (!phone && (el.type === 'tel' || /telefon|phone/i.test(k))) phone = v;
      lines.push(k + ': ' + v);
    });
    var picked = []; page.querySelectorAll('[aria-pressed="true"],[aria-checked="true"]').forEach(function (el) {
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim(); if (t && t.length < 80 && picked.indexOf(t) < 0) picked.push(t);
    });
    if (picked.length) lines.push('', 'Valgt: ' + picked.join(', '));
    var sum = document.querySelector('#rsiP-tilpass .tp-sum, #rsiP-tilpass aside');
    if (sum) lines.push('', 'Oppsummering av reisen:', (sum.innerText || '').replace(/\n{2,}/g, '\n').trim());
    try { var bwn = window.RSIBW && window.RSIBW.note(); if (bwn) lines.push('', bwn); } catch (x) {}
    lines.push('', 'Sendt fra siden: ' + (document.title || '').split(/[|–—-]/)[0].trim()); // ingen lenker i teksten (spamsignal)
    return [['contact[email]', email], ['contact[name]', name], ['contact[phone]', phone], ['contact[Emne]', subject], ['contact[body]', lines.join('\n')]];
  }
  var SUBJ = { trip: 'Reiseforespørsel', msg: 'Melding', tilpass: 'Tilpasset reise' };
  function setFields(sf, fields) {
    fields.forEach(function (kv) {
      var el = sf.querySelector('[name="' + kv[0] + '"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = kv[0]; sf.appendChild(el); }
      el.value = kv[1];
    });
  }
  // Shopifys ekte skjema flyttes inn der designets send-knapp står. Kunden klikker på Shopifys egen knapp inni skjemaet,
  // akkurat som i nyhetsbrevet, slik at robotsjekken godtar innsendingen.
  var FORMS = ['rsiContactForm2', 'rsiContactForm3', 'rsiContactForm4']; // det første kontaktskjemaet på siden brukes ikke
  function park(f) { var p = document.getElementById('rsiFormPark'); if (p && f && f.parentNode !== p) p.appendChild(f); }
  // Navn og e-post er påkrevd før forespørselen kan sendes
  function checkRequired(btn) {
    var en = document.documentElement.lang === 'en';
    var scope = (btn && btn.closest && (btn.closest('.rsi-page') || document)) || document;
    var form = btn && btn.closest && btn.closest('form');
    var area = form || scope;
    var inputs = Array.prototype.slice.call(area.querySelectorAll('input,textarea')).filter(function (el) { return !el.closest('[id^="rsiContactForm"],#rsiCustomerForm') && el.offsetParent !== null; });
    var nameEl = inputs.filter(function (el) { return el.type === 'text' && /navn|name/i.test(fieldLabel(el)); })[0];
    var mailEl = inputs.filter(function (el) { return el.type === 'email'; })[0];
    var ok = true, first = null;
    [[nameEl, function (v) { return v.trim().length > 1; }, en ? 'Please enter your name' : 'Skriv inn navnet ditt'],
     [mailEl, function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim()); }, en ? 'Please enter a valid email address' : 'Skriv inn en gyldig e-postadresse']].forEach(function (r) {
      var el = r[0]; if (!el) return;
      var box = el.parentNode, msg = box.querySelector('.rsi-err-msg');
      if (r[1](el.value || '')) { el.classList.remove('rsi-err'); if (msg) msg.remove(); return; }
      ok = false; if (!first) first = el;
      el.classList.add('rsi-err');
      if (!msg) { msg = document.createElement('small'); msg.className = 'rsi-err-msg'; box.appendChild(msg); }
      msg.textContent = r[2];
      el.addEventListener('input', function onIn() { if (r[1](el.value || '')) { el.classList.remove('rsi-err'); var m = box.querySelector('.rsi-err-msg'); if (m) m.remove(); el.removeEventListener('input', onIn); } });
    });
    if (!nameEl || !mailEl) {
      ok = false;
      var host = (btn && btn.__form && btn.__form.querySelector('.rsi-real-send')) || btn;
      if (host && host.parentNode && !host.parentNode.querySelector('.rsi-err-msg')) {
        var m2 = document.createElement('small'); m2.className = 'rsi-err-msg';
        m2.textContent = en ? 'Fill in your name and email in the last step to send.' : 'Fyll ut navn og e-post i siste steg for å sende.';
        host.parentNode.insertBefore(m2, host.nextSibling);
        setTimeout(function () { if (m2.parentNode) m2.remove(); }, 6000);
      }
    }
    if (first) { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { first.focus(); }, 300); }
    return ok;
  }
  // Som et vanlig Shopify-skjema: feltene kunden skriver i blir selve feltene i Shopify-skjemaet (form-attributtet),
  // og alle send-knapper er ekte innsendingsknapper for det samme skjemaet. Nettleseren sender alt på vanlig måte.
  var FORM_ID = 'rsiContactForm2'; // det første kontaktskjemaet på siden brukes ikke
  function nameFor(el, used) {
    var k = fieldLabel(el), n;
    if (el.type === 'email') n = 'contact[email]';
    else if (el.type === 'tel' || /telefon|phone/i.test(k)) n = 'contact[phone]';
    else if (el.tagName === 'TEXTAREA' && !used['contact[body]']) n = 'contact[body]';
    else if (el.type === 'text' && /^(fullt\s+)?navn$|^(full\s+)?name$/i.test(k.trim()) && !used['contact[name]']) n = 'contact[name]';
    else n = 'contact[' + k.replace(/[\[\]]/g, '').slice(0, 60) + ']';
    while (used[n]) n = n.replace(/\]$/, ' ]');
    used[n] = 1; return n;
  }
  // Nyhetsbrev i designet (f.eks. reiseguiden): Shopifys ekte kundeskjema settes inn med designets utseende
  function placeNewsletter(root) {
    var nl = document.getElementById('rsiCustomerForm'); if (!nl || !root) return;
    var dnl = root.querySelector('form.nlf:not(.rsi-real-nl)'); if (!dnl || !dnl.isConnected || nl.__for === dnl) return;
    nl.className = dnl.className + ' rsi-real-nl'; nl.setAttribute('style', dnl.getAttribute('style') || '');
    var di = dnl.querySelector('input[type="email"]'), db = dnl.querySelector('button');
    var ri = nl.querySelector('input[type="email"]'), rb = nl.querySelector('button[type="submit"]');
    if (di && ri) { ri.className = di.className; ri.setAttribute('style', di.getAttribute('style') || ''); ri.placeholder = di.placeholder || ri.placeholder; ri.setAttribute('aria-label', di.getAttribute('aria-label') || 'E-post'); }
    if (db && rb) { rb.className = (db.className || 'btn') + ' solid'; rb.innerHTML = db.innerHTML; rb.setAttribute('style', 'width:100%;justify-content:center;cursor:pointer;padding:16px 22px;min-height:50px;font-size:12px'); }
    dnl.parentNode.insertBefore(nl, dnl); dnl.style.display = 'none'; nl.__for = dnl;
    if (!nl.__wired) { nl.__wired = true; nl.addEventListener('submit', function () { try { sessionStorage.setItem('rsi-nl', 'guide'); } catch (x) {} if (rb) { rb.style.opacity = '.7'; } }); }
    // takk-melding bare i boksen som faktisk ble brukt
    try {
      var q = new URLSearchParams(location.search);
      if (q.get('customer_posted') === 'true' && sessionStorage.getItem('rsi-nl') === 'guide') {
        sessionStorage.removeItem('rsi-nl');
        var p = document.createElement('p'); p.className = 'nl-ok'; p.style.cssText = 'margin-top:20px;font-weight:500;color:var(--teal)';
        p.textContent = document.documentElement.lang === 'en' ? 'Thank you! You are now subscribed.' : 'Takk! Du er nå påmeldt nyhetsbrevet.';
        nl.parentNode.replaceChild(p, nl); park(nl); nl.__for = null;
        p.scrollIntoView({ block: 'center' });
      }
    } catch (x) {}
  }
  function placeForms(root) {
    if (!root) return;
    var f = document.getElementById(FORM_ID); if (!f) return;
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-rsi-send]')).filter(function (b) { return b.isConnected; });
    if (!btns.length) return;
    // 1) hver send-knapp i designet erstattes av en ekte innsendingsknapp for Shopify-skjemaet
    btns.forEach(function (btn) {
      if (btn.__real && btn.__real.isConnected) return;
      var real = document.createElement('button'); real.type = 'submit'; real.setAttribute('form', FORM_ID);
      real.className = btn.className + ' rsi-real-send'; real.innerHTML = btn.innerHTML;
      var st = btn.getAttribute('style'); if (st) real.setAttribute('style', st.replace(/display:\s*none;?/g, ''));
      btn.parentNode.insertBefore(real, btn.nextSibling);
      btn.style.display = 'none'; btn.setAttribute('data-rsi-hidden', '1'); btn.__real = real; real.__for = btn;
      real.addEventListener('click', function (ev) {
        var code = btn.getAttribute('data-rsi-send');
        if (!checkRequired(btn)) { ev.preventDefault(); return; }
        f.querySelector('[name="contact[Emne]"]').value = SUBJ[code] || 'Forespørsel';
        try { sessionStorage.setItem('rsi-sendt', code || 'trip'); } catch (x) {}
      });
    });
    if (!f.__wired) {
      f.__wired = true;
      f.addEventListener('submit', function () {
        document.querySelectorAll('.rsi-real-send').forEach(function (r) { if (r.offsetWidth) { r.style.opacity = '.7'; setTimeout(function () { r.textContent = document.documentElement.lang === 'en' ? 'Sending …' : 'Sender …'; }, 0); } });
      });
    }
    // 2) kundens felt hører til Shopify-skjemaet
    var page = btns[0].closest('.rsi-page') || document, used = {};
    Array.prototype.slice.call(page.querySelectorAll('input,textarea,select')).forEach(function (el) {
      if (el.closest('[id^="rsiContactForm"],#rsiCustomerForm,form.nlf')) return;
      if (el.type === 'hidden' || el.type === 'submit' || el.type === 'button' || el.type === 'checkbox' || el.type === 'radio') return;
      if (!el.offsetParent) { if (el.getAttribute('form') === FORM_ID) el.removeAttribute('form'); return; }
      el.setAttribute('form', FORM_ID); el.name = nameFor(el, used);
      if (el.name === 'contact[email]' || el.name === 'contact[name]') el.required = true;
      if (el.name === 'contact[email]') el.autocomplete = 'email';
      if (el.name === 'contact[name]') el.autocomplete = 'name';
    });
    // 3) reisevalg og oppsummering (tilpass-flyten) oppdateres fortløpende mens kunden velger
    var picked = []; page.querySelectorAll('[aria-pressed="true"],[aria-checked="true"]').forEach(function (el) {
      if (el.closest('nav,.tabs,.seg')) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim(); if (t && t.length < 80 && picked.indexOf(t) < 0) picked.push(t);
    });
    var sum = page.querySelector('.tp-sum, aside.tp-side, #rsiP-tilpass aside');
    var txt = (picked.length ? 'Valgt: ' + picked.join(', ') : '') + (sum ? '\n\n' + (sum.innerText || '').replace(/\n{2,}/g, '\n').trim() : '');
    var rv = f.querySelector('[name="contact[Reisevalg]"]'); if (rv) rv.value = txt.trim();
  }

  window.RSISend = function (e, subject, state) {
    try {
      var code = /Melding|Message/.test(subject) ? 'msg' : /Tilpass|Tailor/.test(subject) ? 'tilpass' : 'trip';
      try { sessionStorage.setItem('rsi-sendt', code); } catch (x) {}
      if (!checkRequired(e && e.target)) return;
      var realBtn = Array.prototype.slice.call(document.querySelectorAll('.rsi-real-send')).filter(function (b) { return b.offsetWidth; })[0];
      if (realBtn) { realBtn.scrollIntoView({ block: 'center', behavior: 'smooth' }); realBtn.focus(); return; }
      postNative('contact', gather(e && e.target, subject), null);
    } catch (err) {}
  };
  function newsletter(form) {
    var inp = form.querySelector('input[type="email"]'); if (!inp || inp.value.indexOf('@') < 1) { if (inp) inp.focus(); return; }
    postNative('customer', [['contact[email]', inp.value.trim()], ['contact[tags]', 'newsletter'], ['contact[accepts_marketing]', 'true']], backUrl('nyhetsbrev', '1') + '#rsi-nl');
  }



  // ── Ekte bilder i designets bildeflater (.pimg2)
  function rsiSrcset(im, el, src) {
    /* RSI: Shopify-bilder får flere størrelser, så mobilen henter et mindre bilde */
    if (!/\/cdn\/shop\/|cdn\.shopify\.com\//.test(src) || !/\.(webp|jpe?g|png)(\?|$)/i.test(src)) return;
    var base = src.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, ''), j = base.indexOf('?') >= 0 ? '&' : '?';
    im.srcset = [400, 600, 800, 1000, 1400].map(function (w) { return base + j + 'width=' + w + ' ' + w + 'w'; }).join(', ');
    var w = Math.round(el.getBoundingClientRect().width); im.sizes = w > 0 ? w + 'px' : '100vw';
  }
  function putImg(el, src, eager, alt) {
    if (src && typeof src === 'object') { alt = src.a; src = src.u; }
    if (!src) return;
    alt = alt || (window.RSI_ALTS || {})[src] || '';
    el.classList.add('rsi-noph');
    var auto = el.querySelector(':scope > img[data-rsi-auto]');
    if (auto) { if (auto.getAttribute('src') !== src) { rsiSrcset(auto, el, src); auto.src = src; auto.alt = alt; } return; }
    if (el.classList.contains('has-img') || el.querySelector('img')) return;
    var im = document.createElement('img'); im.alt = alt; im.loading = eager ? 'eager' : 'lazy'; if (eager) im.setAttribute('fetchpriority', 'high'); im.decoding = 'async'; rsiSrcset(im, el, src); im.src = src; im.setAttribute('data-rsi-auto', '1');
    im.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:0';
    el.classList.add('has-img'); el.insertBefore(im, el.firstChild);
    var sp = el.querySelector(':scope > span'); if (sp && /^(Bilde|Image)/i.test((sp.textContent || '').trim())) sp.style.display = 'none';
  }

  function clearImg(el) {
    var auto = el.querySelector(':scope > img[data-rsi-auto]'); if (!auto) return;
    auto.remove(); el.classList.remove('has-img'); el.classList.remove('rsi-noph');
    var sp = el.querySelector(':scope > span'); if (sp) sp.style.display = '';
  }
  function fillImages(root, list) {
    // 0) bildeflater med valgt bilde (fra temaredigereren)
    Array.prototype.slice.call(root.querySelectorAll('.pimg2[data-rsi-img]')).forEach(function (el) {
      var u = el.getAttribute('data-rsi-img'); if (u && u.length > 4) { putImg(el, u); el.setAttribute('data-rsi-own', '1'); }
    });
    // 1) kort som lenker til en reise får bildet til den reisen (også etter filtrering)
    var M = window.RSI_IMGS || {};
    Array.prototype.slice.call(root.querySelectorAll('.pimg2')).forEach(function (el) {
      if (el.classList.contains('has-img') && !el.querySelector(':scope > img[data-rsi-auto]')) return; // ekte bilde fra designet/Shopify
      if (el.hasAttribute('data-rsi-own')) return; // produktets egne bilder
      var n = el, hit = null, hitUrl = null, found = false;
      for (var d = 0; d < 5 && n && !found; d++) {
        var as = n.tagName === 'A' ? [n] : Array.prototype.slice.call(n.querySelectorAll ? n.querySelectorAll('a[href]') : []);
        if (as.length) {
          found = true;
          var urls = as.map(function (a) { return (a.getAttribute('href') || '').split(/[?#]/)[0]; }).filter(function (u) { return M[u]; });
          var uniq = urls.filter(function (u, i) { return urls.indexOf(u) === i; });
          if (uniq.length === 1) { hit = M[uniq[0]]; hitUrl = uniq[0]; }
        }
        n = n.parentElement;
      }
      if (hit) putImg(el, hit, false, (window.RSI_ALTS || {})[hitUrl]); else if (found) clearImg(el);
    });
    // 2) resten av bildeflatene får produktets egne bilder, i rekkefølge
    if (list && list.length) {
      var k = 0;
      Array.prototype.slice.call(root.querySelectorAll('.pimg2:not(.has-img)')).forEach(function (el) {
        if (el.closest('a[href]')) return;
        if (k < list.length) { putImg(el, list[k], k < 2); k++; el.setAttribute('data-rsi-own', '1'); }
      });
      galleryExtras(root, list);
    }
  }
  // Produktgalleriet: legg til produktbilder som ikke vises andre steder på siden,
  // slik at alle bildene kan sveipes gjennom på mobil. På desktop vises fortsatt bare de tre første.
  function galleryExtras(root, list) {
    var gal = root.querySelector('.gal'); if (!gal || gal.getAttribute('data-rsi-gal')) return;
    gal.setAttribute('data-rsi-gal', '1');
    var used = {};
    Array.prototype.slice.call(root.querySelectorAll('img')).forEach(function (im) { used[(im.getAttribute('src') || '').split('?')[0]] = 1; });
    list.forEach(function (it) {
      var u = it && typeof it === 'object' ? it.u : it; if (!u || used[u.split('?')[0]]) return;
      var d = document.createElement('div'); d.className = 'pimg2 gal-x'; d.setAttribute('data-rsi-own', '1');
      gal.appendChild(d); putImg(d, it, false); used[u.split('?')[0]] = 1;
    });
    setupGallery(gal);
  }
  function setupGallery(gal) {
    var slides = Array.prototype.slice.call(gal.children).filter(function (el) { return el.classList.contains('has-img'); });
    if (slides.length) gal.classList.add('has-photos');
    if (slides.length === 1) gal.classList.add('gal-one');
    if (slides.length < 2) return;
    var dots = document.createElement('div'); dots.className = 'gal-dots'; dots.setAttribute('aria-hidden', 'true');
    slides.forEach(function (sl, i) {
      var d = document.createElement('i'); if (!i) d.className = 'on';
      d.addEventListener('click', function () { gal.scrollTo({ left: sl.offsetLeft - gal.offsetLeft, behavior: 'smooth' }); });
      dots.appendChild(d);
    });
    gal.parentNode.insertBefore(dots, gal.nextSibling);
    var t = null;
    gal.addEventListener('scroll', function () {
      if (t) cancelAnimationFrame(t);
      t = requestAnimationFrame(function () {
        var mid = gal.scrollLeft + gal.clientWidth / 2, best = 0, bd = 1e9;
        slides.forEach(function (sl, i) { var c = sl.offsetLeft - gal.offsetLeft + sl.offsetWidth / 2, dd = Math.abs(c - mid); if (dd < bd) { bd = dd; best = i; } });
        Array.prototype.forEach.call(dots.children, function (d, i) { d.className = i === best ? 'on' : ''; });
      });
    }, { passive: true });
  }
  // Reiseguiden: kategorier og innlegg sortert etter Google Search Console (klikk, deretter visninger),
  // fordelt rad for rad i spalter. Destinasjonsguidene vises allerede store øverst, så de står sist.
  // Tallene er et øyeblikksbilde (siste 3 måneder per oktober 2026) og kan oppdateres her.
  var GSC = {"hva-koster-det-a-reise-til-bali":[160,4708],"hvor-bor-du-bo-pa-bali-guide-til-de-beste-omradene":[56,1826],"bali-vs-thailand":[44,1021],"bali-med-barn":[35,986],"regntid-pa-bali":[12,3381],"valuta-priser-og-tipping-pa-bali-dette-bor-du-vite-for-reisen":[12,1691],"balinesisk-kultur-skikk-og-bruk-for-turister":[9,274],"de-storste-feilene-nordmenn-gjor-pa-bali-og-hvordan-du-unngar-dem":[9,151],"kart-over-bali":[8,961],"hvor-mange-dager-pa-bali":[7,562],"beste-tid-a-reise-til-bali":[9,1921],"visum-bali":[5,560],"nusa-penida-vs-nusa-lembongan-hva-er-best-for-din-bali-reise":[5,152],"14-dager-pa-bali-perfekt-rute-for-forstegangsreisende":[5,146],"fly-til-bali-fra-norge-2027":[4,196],"10-ting-reise-til-bali":[4,181],"bali-ferie-par":[4,157],"matkultur-pa-bali-dette-ma-du-smake":[3,377],"gili-islands-guide":[3,237],"nusa-penida":[3,150],"bryllupsreise-til-bali":[3,102],"reise-til-bali":[2,623],"ferie-bali":[2,386],"pakkereise-bali":[2,309],"uluwatu-vs-canggu":[2,158],"ubud-guide":[2,121],"uluwatu-guide":[2,102],"bali-for-forstegangsreisende-alt-du-ma-vite-for-reisen":[4,1080],"komodo-guide":[2,72],"hans-petter-og-synne-bryllupsreise-bali":[1,154],"sjekkliste-for-bali-reisen":[1,84],"templer-pa-bali-du-bor-besoke-en-guide-til-oyas-mest-ikoniske-helligdommer":[1,51],"lombok-guide":[1,16],"er-bali-trygt-sikkerhet-for-norske-reisende":[0,185],"yoga-pa-bali-hvor-og-hvorfor":[0,86],"pakkereiser-vs-skreddersydde-reiser-hva-er-best":[0,70],"lovina-guide":[0,37],"canggu-guide":[0,34],"privat-sjafor-pa-bali-er-det-verdt-det":[0,31],"slik-fungerer-vare-dagsturer-og-pakker":[0,30],"transport-pa-bali-slik-kommer-du-deg-rundt-enkelt-og-trygt":[0,29],"hvor-bor-du-bo-paa-bali-guide-til-de-beste-omradene":[0,25],"hva-koster-aktiviteter-og-dagsturer-pa-bali-prisguide-2026":[0,24],"aktiv-ferie-pa-bali-trening-padel-og-opplevelser":[0,23],"surf-lifestyle-pa-bali":[0,20],"seminyak-guide":[0,17],"ubud-kulturhjertet-av-bali":[0,17],"dagsturer-pa-bali-perfekt-for-korte-opphold":[0,12],"10-dager-pa-bali-den-ultimate-reiseguiden-readysetisland":[0,12],"flytte-til-bali":[0,9],"reisegaranti-og-trygghet-nar-du-reiser-til-bali":[0,8],"hvor-bor-du-bo-pa-bali-guide-lost-omradene":[0,7],"hvor-bor-du-ba-paa-bali-guide-til-de-beste-omradene":[0,6],"aktiviteter-pa-bali-de-10-beste-opplevelsene-du-ikke-vil-ga-glipp-av-readysetisland":[0,6],"hvor-bor-du-bo-bali-guide-til-de-beste-omradene":[0,3],"flerdagsturer-pa-bali-se-mer-stress-mindre":[0,3],"hvor-bor-du-bo-pa-bali-guide-til-de-best-omradene":[0,2],"dette-bor-du-vite-for-reisen":[0,1],"fly-til-bali-fly-anbefalt-rute-fra-norge-til-bali-2027":[0,1],"fly-til-bali-from-norge-2027":[0,1],"hva-koster-det-a-reise-bali":[0,1],"hvor-bor-du-bo-pa-bali":[0,1],"hvor-bor-du-bo-pa-bali-guide-til-de-omradene":[0,1],"hvor-bor-du-bo-pa-bali-guide-til-dette-omradene":[0,1],"hvor-bor-du-bo-paa-bali":[0,1],"hvor-bor-du-bo-paa-bali-guide-til-de-best-omradene":[0,1],"hvor-bor-du-bo-pax-bali-guide-til-de-beste-omradene":[0,1],"hvor-bor-du-pa-bali-guide-til-de-beste-omradene":[0,1],"reise-to-bali":[0,1],"transport-pa-bali-slik-kommer-du-deg-rundt-enkelt-og-tryggest":[0,1],"valuta-priser-og-tipping-pa-bali-dette-bor-du-vi-te-for-reisen":[0,1],"beste-tid-a-reise-bali":[0,1],"mt-batur-hike-vs-jeep-hva-bor-du-velge":[0,1]};
  function rankOf(a) { var x = GSC[a.getAttribute('data-rsi-a') || '']; return x ? x[0] * 1e6 + x[1] : 0; }
  function clicksOf(a) { var x = GSC[a.getAttribute('data-rsi-a') || '']; return x ? x[0] : 0; }
  function viewsOf(a) { var x = GSC[a.getAttribute('data-rsi-a') || '']; return x ? x[1] : 0; }
  function colsFor() { var w = window.innerWidth; return w > 1000 ? 3 : (w > 640 ? 2 : 1); }
  function layoutGuide(grid) {
    var cats = grid.__cats, n = colsFor();
    if (grid.__n === n) return; grid.__n = n;
    grid.innerHTML = ''; grid.classList.add('rsi-cols'); grid.style.gridTemplateColumns = 'repeat(' + n + ',minmax(0,1fr))';
    var cols = [], h = [];
    for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'rsi-col'; grid.appendChild(c); cols.push(c); h.push(0); }
    var big = -1, bigN = 0;
    cats.forEach(function (ag, i) {
      var k = i < n ? i : h.indexOf(Math.min.apply(null, h));
      // destinasjonsguidene havner ikke under den lengste kategorien (Planlegging), men i den korteste av de andre spaltene
      if (ag.__guides && n > 1 && k === big) {
        var best = -1; h.forEach(function (v, j) { if (j !== big && (best < 0 || v < h[best])) best = j; }); k = best;
      }
      cols[k].appendChild(ag);
      var items = ag.querySelectorAll('li').length;
      if (i < n && items > bigN) { bigN = items; big = k; }
      h[k] += items + 3 + ag.querySelectorAll('.rsi-th').length * 1.5;
    });
  }
  function decorateLists(root) {
    var M = window.RSI_IMGS || {};
    Array.prototype.slice.call(root.querySelectorAll('.agrid')).forEach(function (grid) {
      if (!grid.__cats) {
        var cats = Array.prototype.slice.call(grid.querySelectorAll('.ag'));
        cats.forEach(function (ag) {
          var ul = ag.querySelector('ul'); if (!ul) return;
          var lis = Array.prototype.slice.call(ul.children);
          lis.forEach(function (li, i) { li.__i = i; });
          lis.sort(function (x, y) { var ax = x.querySelector('a'), ay = y.querySelector('a'); return (rankOf(ay) - rankOf(ax)) || (x.__i - y.__i); });
          lis.forEach(function (li) { ul.appendChild(li); });
          ag.__clicks = lis.reduce(function (t, li) { return t + clicksOf(li.querySelector('a')); }, 0);
          ag.__views = lis.reduce(function (t, li) { return t + viewsOf(li.querySelector('a')); }, 0);
          var guides = lis.filter(function (li) { return /guide|nusa-penida/.test(li.querySelector('a').getAttribute('data-rsi-a') || ''); }).length;
          ag.__guides = guides >= lis.length / 2;
          // bilde på de to mest leste innleggene som har bilde
          var picked = 0;
          lis.forEach(function (li) {
            var a = li.querySelector('a'); if (picked >= 2 || a.classList.contains('rsi-tl')) return;
            var u = (a.getAttribute('href') || '').split(/[?#]/)[0]; if (!M[u]) return;
            var th = document.createElement('span'); th.className = 'rsi-th'; th.setAttribute('aria-hidden', 'true');
            var im = document.createElement('img'); im.alt = (window.RSI_ALTS || {})[u] || (a.textContent || '').trim(); im.loading = 'lazy'; im.decoding = 'async';
            im.src = M[u].replace(/width=\d+/, 'width=440'); im.srcset = M[u].replace(/width=\d+/, 'width=220') + ' 1x, ' + M[u].replace(/width=\d+/, 'width=440') + ' 2x';
            th.appendChild(im);
            var tt = document.createElement('span'); tt.className = 'rsi-tt';
            while (a.firstChild) tt.appendChild(a.firstChild);
            a.appendChild(th); a.appendChild(tt); a.classList.add('rsi-tl'); li.classList.add('rsi-tl-li');
            picked++;
          });
          // innlegg med bilde øverst, deretter resten etter popularitet
          lis.filter(function (li) { return li.classList.contains('rsi-tl-li'); }).reverse().forEach(function (li) { ul.insertBefore(li, ul.firstChild); });
        });
        cats.forEach(function (ag, i) { ag.__i = i; });
        cats.sort(function (x, y) { return (x.__guides - y.__guides) || (y.__clicks - x.__clicks) || (y.__views - x.__views) || (x.__i - y.__i); });
        grid.__cats = cats;
        window.addEventListener('resize', function () { layoutGuide(grid); });
      }
      layoutGuide(grid);
    });
  }
  // Designbildene (bakgrunnsbilder) gjøres om til ekte <img> med alt-tekst fra designets bildetekst
  function promotePhotos(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('.pimg2.ph:not(.has-img):not(.rsi-noph), .pf .pimg:not(.rsi-noph)')).forEach(function (el) {
      if (el.querySelector(':scope > img')) return;
      var cs = getComputedStyle(el), m = /url\(["']?([^"')]+)["']?\)/.exec(cs.backgroundImage || ''); if (!m) return;
      var cap = el.querySelector(':scope > span'), alt = cap ? (cap.textContent || '').replace(/^\s*(Bilde|Image)\s*:\s*/i, '').trim() : '';
      var fc = el.closest('figure') && el.closest('figure').querySelector('figcaption');
      if (fc && fc.querySelector('b')) {
        var bn = fc.querySelector('b'), role = bn.nextSibling && bn.nextSibling.nodeType === 3 ? bn.nextSibling.textContent.replace(/[·–-]/g, '').trim() : '';
        alt = bn.textContent.trim() + (role ? ', ' + role.toLowerCase() + (document.documentElement.lang === 'en' ? ', ReadySetIsland' : ' i ReadySetIsland') : '');
      }
      var im = document.createElement('img'); im.className = 'rsi-phimg'; im.src = m[1]; im.alt = alt; im.loading = 'lazy'; im.decoding = 'async';
      im.style.objectPosition = cs.backgroundPosition;
      el.classList.add('rsi-noph'); el.insertBefore(im, el.firstChild);
    });
  }
  window.RSIPromotePhotos = promotePhotos;
  document.addEventListener('DOMContentLoaded', function () { document.querySelectorAll('.rj').forEach(function (r) { if (!r.closest('[data-rsi-mount]')) promotePhotos(r); }); });
  window.RSIFillImages = fillImages;

  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (o) {
    if (typeof o === 'function') o = o(this.state);
    this.state = Object.assign({}, this.state, o);
    var self = this;
    if (!self.__q) { self.__q = true; Promise.resolve().then(function () { self.__q = false; self.__render(); }); }
  };
  window.DCLogic = DCLogic;

  window.RSIDC = {
    mount: function (tplEl, mountEl, Comp, props) {
      var frag = tplEl.content.cloneNode(true), binds = [];
      mountEl.setAttribute('data-rsi-mount', '');
      compile(frag, binds);
      var c = new Comp(props || {});
      var imgT = null, imgList = (props && props.imgs) || null;
      c.__render = function () {
        update(binds, c.renderVals());
        if (imgT) clearTimeout(imgT);
        imgT = setTimeout(function () { fillImages(mountEl, null); decorateLists(mountEl); promotePhotos(mountEl); placeForms(mountEl); placeNewsletter(mountEl); }, 60);
      };
      update(binds, c.renderVals());
      fixLinks(frag);
      while (mountEl.firstChild) mountEl.removeChild(mountEl.firstChild); // fjern HTML-reserven (for søkemotorer uten JavaScript)
      mountEl.addEventListener('submit', function (e) {
        if (e.target && /^rsi(Contact|Customer)Form/.test(e.target.id || '')) return; // Shopifys ekte skjemaer sendes som vanlig
        e.preventDefault();
        var f = e.target; if (f && f.classList && (f.classList.contains('nlf') || f.querySelector('input[type="email"]') && !f.querySelector('textarea'))) {
          if (f.classList.contains('nlf')) newsletter(f);
        }
      }, true);
      mountEl.appendChild(frag);
      c.__render();
      if (c.componentDidMount) c.componentDidMount();
      try {
        var q = new URLSearchParams(location.search), code = null, err = document.getElementById('rsiContactErr') || document.getElementById('rsiContactErr2') || document.getElementById('rsiContactErr3') || document.getElementById('rsiContactErr4');
        if (q.get('contact_posted') === 'true' || document.getElementById('rsiContactOk') || document.getElementById('rsiContactOk2') || document.getElementById('rsiContactOk3') || document.getElementById('rsiContactOk4')) code = sessionStorage.getItem('rsi-sendt') || 'trip';
        if (err) {
          code = null;
          var box = document.createElement('div'); box.className = 'tip'; box.style.cssText = 'margin:24px auto;max-width:760px;border-left-color:#a14a3a';
          box.innerHTML = '<small style="color:#a14a3a">' + (document.documentElement.lang === 'en' ? 'Your enquiry was not sent' : 'Forespørselen ble ikke sendt') + '</small>';
          box.appendChild(document.createTextNode(err.getAttribute('data-msg') || ''));
          mountEl.insertBefore(box, mountEl.firstChild); box.scrollIntoView({ block: 'center' });
        }
        if (code) { window.__rsiSent = code; sessionStorage.removeItem('rsi-sendt'); c.setState({ sent: code === 'tilpass' ? true : code }); setTimeout(function () { var el = mountEl.querySelector('.sent'); if (el) el.scrollIntoView({ block: 'center' }); }, 200); }
      } catch (x) {}
      var imgs = (props && props.imgs) || null;
      fillImages(mountEl, imgs); decorateLists(mountEl); placeForms(mountEl); placeNewsletter(mountEl);
      mountEl.classList.add('rsi-ready');
      promotePhotos(mountEl);
      if (location.hash && location.hash.length > 1) {
        var tgt = null; try { tgt = mountEl.querySelector(location.hash); } catch (x) {}
        if (tgt) setTimeout(function () { window.scrollTo({ top: tgt.getBoundingClientRect().top + window.scrollY - 80, behavior: 'auto' }); }, 120);
      }
      setTimeout(function () { fillImages(mountEl, imgs); }, 600);
      return c;
    }
  };
})();